import { Button, ButtonColor } from "@swivl-mono/ui";
import { PiWarning } from "react-icons/pi";
import Logo from '../../Views/Login/Assets/SwivlLogo.png';

const ErrorView = () => {
  return (
    <div className="size-full flex flex-col items-center justify-center gap-8">
      <img src={Logo} alt="Swivl Logo" className="max-w-48 object-cover" />
      <div className="flex flex-col items-center gap-1">
        <span className="text-gray-400 tracking-wide font-bold">404</span>
        <h1 className="text-3xl text-black font-bold">An error has occurred</h1>
        <PiWarning className="text-grey-800 size-10" />
      </div>
      <div className="mb-4">
        <Button color={ButtonColor.ORANGE}>
          <a href="mailto:support@tryswivl.com?subject=swivl 404 error">Contact Support</a>
        </Button>
      </div>
    </div>
  )
}

export default ErrorView;
